import PropTypes from "prop-types";
import Dropdown from "@shared/v2/Dropdown";
import Button from "@shared/v2/Button";

export const CustomControl = ({ componentProps, children }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Dropdown.Control {...componentProps}>
    <Button schema="tertiary" className="!tw-py-0">
      <span className="tw-flex tw-items-center tw-min-w-[120px] tw-w-full">{children}</span>
    </Button>
  </Dropdown.Control>
);

CustomControl.propTypes = {
  componentProps: PropTypes.shape().isRequired,
  children: PropTypes.node.isRequired,
};

export const CustomSingleValue = ({ children, componentProps }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Dropdown.SingleValue preserveStyle {...componentProps}>
    <span className="tw-text-11d tw-font-bold">{children}</span>
  </Dropdown.SingleValue>
);

CustomSingleValue.propTypes = {
  componentProps: PropTypes.shape().isRequired,
  children: PropTypes.node.isRequired,
};
